import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.less";
import { AppProvider } from "context/index";
import { version as appVersion, name as appName } from "../package.json";

console.log('==APP Version==', `${appName}@${appVersion}`)

ReactDOM.render(
  <AppProvider>
    <App />
  </AppProvider>,
  document.getElementById("root")
);

if (process.env.REACT_APP_ADYEN_ENV === 'test') {
  const VConsole = require('vconsole');
  new VConsole();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
